import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { LoadingProvider } from './context/LoadingContext';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import { GlobalStyle } from './styles/GlobalStyle';
import './i18n';
import './index.css';

// ── Silenciar erros que NASCEM em extensão do navegador (só em dev) ──────────
// Extensões que embrulham window.fetch (Claude in Chrome, SimilarWeb, etc.)
// re-lançam o "Failed to fetch" num contexto delas, sem catch. O código do app
// já trata tudo (fetchWithTimeout nunca lança), mas o overlay do dev server
// captura a rejeição órfã DA EXTENSÃO e cobre a tela como se fosse bug nosso.
// Filtro cirúrgico: só ignora o que tem chrome-extension:// no stack — erro
// real do app continua aparecendo no overlay normalmente.
if (process.env.NODE_ENV === 'development') {
  const veioDeExtensao = (err: unknown): boolean =>
    String((err as any)?.stack || '').includes('chrome-extension://');
  // O client do webpack-dev-server registra o handler ANTES deste código e não
  // respeita preventDefault — o overlay abre mesmo assim. Então, além de
  // prevenir, removemos o iframe do overlay logo depois que ele nasce. Só
  // quando o stack aponta extensão; erro real do app continua cobrindo a tela.
  const derrubarOverlayDeExtensao = () => {
    setTimeout(() => {
      const ov = document.getElementById('webpack-dev-server-client-overlay');
      if (ov) ov.remove();
    }, 60);
  };
  window.addEventListener('unhandledrejection', (e) => {
    if (veioDeExtensao(e.reason)) {
      e.preventDefault();
      derrubarOverlayDeExtensao();
    }
  });
  window.addEventListener('error', (e) => {
    if (veioDeExtensao(e.error) || String(e.filename || '').startsWith('chrome-extension://')) {
      e.preventDefault();
      derrubarOverlayDeExtensao();
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <LoadingProvider>
            <AuthProvider>
              <GlobalStyle />
              <App />
            </AuthProvider>
          </LoadingProvider>
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
